import React from 'react'
import { MetricContainer } from '../components/MetricContainer/MetricContainer'
import Styles from './AgeGenderDistribution.module.scss'
import GroupedBarChart from '../components/GroupedBarChart/GroupedBarChart'
import { Spin } from 'common/Spin/Spin'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'

interface AgeGenderDistributionProps {
  data?: {
    age_gender_distribution: Array<{
      range: string
      male: number
      female: number
      unknown: number
    }>
    error_title?: string
    error_message?: string
  }
  isFetching: boolean
}

export const AgeGenderDistribution: React.FC<AgeGenderDistributionProps> = ({ data, isFetching }) => {
  const transformedData =
    data?.age_gender_distribution.map((item) => ({
      range: item.range,
      series: [
        { name: 'Male', value: item.male, color: 'rgba(0, 119, 255, 0.80)' },
        { name: 'Female', value: item.female, color: 'rgba(255, 0, 17, 0.40)' },
        { name: 'Did not share', value: item.unknown, color: 'rgba(95, 145, 201, 0.33)' },
      ],
    })) || []

  const isEmpty = data && data.age_gender_distribution.length === 0

  let content
  if (isFetching) {
    content = (
      <div className={Styles.loadingContainer} data-testid="loading">
        <Spin />
      </div>
    )
  } else if (!data) {
    content = <div className={Styles.loadingContainer}>Error loading data</div>
  } else if (data && data.error_title && data.error_message) {
    content = (
      <div className={Styles.errorContainer}>
        <Heading level={5}>{data.error_title}</Heading>
        <Text>{data.error_message}</Text>
      </div>
    )
  } else if (isEmpty) {
    content = <div className={Styles.loadingContainer}>This data isn't ready yet, check back soon!</div>
  } else {
    content = (
      <div className={Styles.container} data-testid="age-gender-distribution-chart">
        <GroupedBarChart data={transformedData} />
      </div>
    )
  }

  return (
    <MetricContainer name="Audience by Age and Gender" tooltip="Distribution of audience by age groups and gender">
      {content}
    </MetricContainer>
  )
}
